import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, ArrowDownRight } from "@phosphor-icons/react";
import { C } from "./ccUtils";

export function CcPanel({ title, icon: Icon, aside, children, className = "", bodyClass = "", testid, delay = 0 }) {
  return (
    <motion.section data-testid={testid} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.45, delay }}
      className={`relative flex flex-col min-h-0 overflow-hidden rounded-xl border border-neutral-800 bg-[#0F0F0F] ${className}`}>
      <header className="flex items-center gap-2 px-4 pt-3 pb-2 shrink-0">
        {Icon && <Icon size={15} weight="duotone" className="text-[#73bf44] shrink-0" />}
        <h2 className="text-xs font-heading font-semibold uppercase tracking-wider text-neutral-300 truncate">{title}</h2>
        {aside != null && <div className="ml-auto text-[11px] font-mono text-neutral-500 shrink-0">{aside}</div>}
      </header>
      <div className={`flex-1 min-h-0 px-4 pb-3 ${bodyClass}`}>{children}</div>
    </motion.section>
  );
}

export function AnimatedValue({ value, className = "", style, testid }) {
  return (
    <motion.span key={value} initial={{ opacity: 0.15, y: 5 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.35 }}
      className={`inline-block ${className}`} style={style} data-testid={testid}>
      {value}
    </motion.span>
  );
}

export function Delta({ v, label, testid }) {
  if (v == null) return null;
  const up = v > 0;
  const Icon = up ? ArrowUpRight : ArrowDownRight;
  return (
    <span data-testid={testid} className="inline-flex items-center gap-0.5 text-[10px] font-mono" style={{ color: up ? C.amber : C.green }}>
      <Icon size={11} weight="bold" />{`${up ? "+" : ""}${Math.round(v)}%`}{label && <span className="text-neutral-500 ml-1">{label}</span>}
    </span>
  );
}

export function Empty({ children }) {
  return <div className="h-full flex items-center justify-center text-xs text-neutral-600 text-center">{children}</div>;
}

export function SubBlock({ title, children, className = "", testid }) {
  return (
    <div data-testid={testid} className={`rounded-lg bg-[#171717] border border-neutral-800 p-3 flex flex-col min-h-0 ${className}`}>
      <div className="text-[10px] font-mono uppercase tracking-wider text-neutral-500 mb-2">{title}</div>
      {children}
    </div>
  );
}
